// extracted by mini-css-extract-plugin
export var carrierIcon = "_xk-0";
export var carrierLogo = "_xk-1";
export var detailsSection = "_xk-2";